const template = `
<div class="content-region invoice print-only">
    <div class="logo"><img title="Electric Imp" src="/img/electric_imp_logo.png" /></div>
    <div class="invoice-id">INVOICE {{id}}</div>
    <div class="payable-to">
        <div class="address">
            5150 El Camino Real<br>
            Suite C31<br>
            Los Altos, CA 94022 USA<br>
            +1 650 383 7143
        </div>
    </div>
    <div class="billed-to">
        <label>Date</label>
        <div>{{#date_simple_UTC}}{{created_at}}{{/date_simple_UTC}} UTC</div>
        <label>{{#if credit}}Paid{{else}}Bill{{/if}}&nbsp;To</label>
        <div class="address">
            {{#with account.attributes}}
                {{username}}<br>
                {{#if organization}}{{organization}}<br>{{/if}}
                {{#if given_name}}
                    {{given_name}}
                    {{#if family_name}}
                        {{family_name}}
                    {{/if}}
                    <br>
                {{else}}
                    {{#if family_name}}
                        {{family_name}}
                        <br>
                    {{/if}}
                {{/if}}
                {{#if billing_contact_email}}
                    {{billing_contact_email}}<br>
                {{/if}}
                {{email}}<br>
                {{#if phone }}{{phone}}{{/if}}
            {{/with}}
        </div>
    </div>
    <div class="date-amount-section">
        <div class="details-section"> 
            <label>Total
                {{#if credit}}
                    Credit
                {{else}}
                    Charges
                {{/if}}
            </label><strong {{#if credit}}class="credit"{{/if}}>{{amount_str}} USD</strong> 
            <label>Description</label><div>{{description}}</div>
            {{#unless credit}}
                <label>Total Connections</label><div class="total-connections"></div>
                <label>Data Credited</label><div class="total-data"></div>
            {{/unless}}
        </div>
        <h1 class="title">
            {{#if credit}}
                Credit
            {{else}}
                Charges
            {{/if}}
        </h1>
    </div>
    <div class="list-view content"></div>
    <div class="list-view total">
        {{#if credit}}
            <div class="line-item header">
                <span class="date-column">Date (UTC)</span>
                <span class="charge">{{#if credit}}Credit{{else}}Charge{{/if}}</span>
                <span class="event">Event</span>
                <span class="qty">QTY</span>
                <span class="description">Description</span>
                <span class="details">Details</span>
            </div>
            <div data-id="{{id}}" class="line-item">
                <span class="date-column">{{#date_simple_UTC}}{{created_at}}{{/date_simple_UTC}}</span>
                <span class="credit charge">{{amount_str}}</span>
                <span class="event">Credit</span>
                <span class="qty">1</span>
                <span class="description">{{description}}</span>
            </div>
        {{/if}}
        <div data-id="total" class="line-item">
            <span class="">
                Total
                {{#if credit}}
                        Credit
                    {{else}}
                        Charges
                    {{/if}}
                </span>
                <span {{#if credit}}
                        colspan="4" class="credit"
                    {{else}}
                        colspan="5" class="credit"
                    {{/if}}>{{amount_str}}
                </span>
                {{#unless credit}}
                    <div data-id="connections">
                        <span>Connections</span>
                        <span class="total-connections"></span>
                    </div>
                    <div data-id="data">
                        <span>Data Credited</span>
                        <span class="total-data"></span>
                    </div>
                {{/unless}}
            </div>
    </div>
    <div class="terms">
        This order is subject to Electric Imp's <a href="https://electricimp.com/terms/" target="_blank">terms and conditions</a>.
    </div>
</div>`;

import Backbone from 'backbone';
import Radio from 'backbone.radio';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import LineItemListView from '@/views/modules/billing_line_item_list';

function mbify(data) {
    const MB = 1024 * 1024;
    if ( !data || data === 0 ) return '--'; 
    if (data % MB === 0)  { 
        return '' + (data / MB) + ' MB'; 
    }
    return '' + data + ' bytes';
}

var InvoiceView = Marionette.View.extend({
    template: Handlebars.compile(template),
    regions: {
        device_count: '.device-count',
        deployed_build: '.deployed-build',
        list_view: '.list-view'
    },
    initialize: function() {
        const lineitems_collection = Radio.request('api', 'lineitem');
        this.model.fetch().then( (resp)=>{
            if ( this.model.get('items') && this.model.get('items').length > 0 ) {
                const items = [];
                this.model.get('items').forEach((item)=> {
                    let s = Radio.request('api', item.type, item.id);
                    if (!s || !s.id) {

                        lineitems_collection.add(item);
                        s = Radio.request('api', item.type, item.id);
                    }
                    items.push(s);
                });
                this.model.set('items', items);
                this.items = items;
                this.render();
            }
        });
    },
    tagName: 'div',
    className: 'standard-layout',
    ui: {
        total_connections: '.total-connections',
        total_data: '.total-data',
        change_email: '.change_email',
        show_all_details: '.show-all-details',
        show_details: '.show-details',
        close_details: '.close-details',
    },
    events: {
        'click @ui.show_all_details' : 'show_all_details',
    },
    modelEvents: {
        'change': 'render',
        'update': 'render'
    },
    templateContext: function() {
        let account = Radio.request('global', 'primary_account');
        let amount = this.model.get('amount');
        let credit = false;
        let amount_str;

        if ( amount && amount < 0 ) {
            amount_str = '$' + Number(-amount).toFixed(2);
        } else if ( amount ) {
            amount_str = '$' + Number(amount).toFixed(2);
            credit = true;
        }

        return {
            items: this.model.get('items'),
            current_charges: this.model.id === 'current-charges',
            credit,
            amount_str,
            account
        };
    },
    onRender: function() {
        const amount = this.model.get('amount');
        if ( amount && amount < 0 ) {
            const collection = new Backbone.Collection(this.items);

            this.showChildView('list_view', new LineItemListView({
                collection
            }));
            const line_items = this.getChildView('list_view');
            line_items.prep_list(this.items);
        }
        let total_connections = 0;
        let total_data = 0;
        if (this.items) {
            this.items.forEach( (i) => {
                if ( i.get('item_type') === 'connection' ) {
                    total_connections = total_connections + Number(i.get('count'));
                    total_data = total_data + Number(i.get('bytes'));
                } else if ( i.get('item_type') === 'refill' ) {
                    total_data = total_data = total_data + Number(i.get('bytes'));
                }
            });
        }
        this.ui.total_data.text( mbify(total_data) );
        this.ui.total_connections.text( total_connections );
    },
    show_all_details: function(e) {
        this.ui.details_row.attr('class', 'details-row-active');
    },
    close_all_details: function(e) {
        this.ui.details_row_active.attr('class', 'details-row');
    }
});

export default InvoiceView;

